import styled from "styled-components";

export const DivContainerFull = styled.div`
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
`;
